import * as React from 'react';
import { useParams } from '@tanstack/react-router';
import { SideNav } from '../SideNav';
import { TopNav } from '../TopNav';
import { MainContent } from '../MainContent';
import { RouterMenuItem } from '../RouterMenuItem';
import { useMediaQuery, useTheme } from '@mui/material';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SourceIcon from '@mui/icons-material/Source';
import MenuList from '@mui/material/MenuList';
import { APP_HEADER_HEIGHT } from './appHeader';


const drawerWidth = 240;

export const AuthLayout = ({ children }: { children: React.ReactNode }) => {

    const [open, setOpen] = React.useState(false);
    const { reviewId } = useParams({ strict: false });

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    React.useEffect(() => {
        if (isMobile) {
            setOpen(false);
        }
    }, [isMobile]);

    const prevReviewIdRef = React.useRef<string | undefined>(undefined);
    React.useEffect(() => {
        if (!isMobile && reviewId && prevReviewIdRef.current !== reviewId) {
            setOpen(true);
        }
        prevReviewIdRef.current = reviewId;
    }, [reviewId, isMobile]);

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleNavItemClick = () => {
        if (isMobile) {
            setOpen(false);
        }
    };

    return (

        <Box sx={{ display: 'flex' }}>
            <TopNav open={open} onOpen={handleDrawerOpen} />
            <SideNav width={drawerWidth} topOffset={APP_HEADER_HEIGHT} open={open} onClose={handleDrawerClose} >
                <MenuList>
                    <RouterMenuItem key='reviews' to="/dashboard" activeOptions={{ exact: true }} onClick={handleNavItemClick}>
                        <ListItemIcon>
                            <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText primary='Reviews' />
                    </RouterMenuItem>
                </MenuList>
                {reviewId && (
                    <>
                        <Divider />
                        <MenuList>
                            <RouterMenuItem key='overview' to="/reviews/$reviewId/overview" params={{ reviewId }} onClick={handleNavItemClick}>
                                <ListItemIcon>
                                    <AssignmentIcon />
                                </ListItemIcon>
                                <ListItemText primary='Overview' />
                            </RouterMenuItem>
                            <RouterMenuItem key='sources' to="/reviews/$reviewId/sources" params={{ reviewId }} onClick={handleNavItemClick}>
                                <ListItemIcon>
                                    <SourceIcon />
                                </ListItemIcon>
                                <ListItemText primary='Sources' />
                            </RouterMenuItem>
                            <RouterMenuItem key='deduplication' to="/reviews/$reviewId/deduplication" params={{ reviewId }} onClick={handleNavItemClick}>
                                <ListItemIcon>
                                    <SourceIcon />
                                </ListItemIcon>
                                <ListItemText primary='Deduplication' />
                            </RouterMenuItem>
                        </MenuList>
                    </>
                )}
            </SideNav>
            <MainContent
                open={open}
                shrinkWidth={drawerWidth}
            >
                {children}
            </MainContent>
        </Box>
    )
}
